<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Allotment Mutation</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <a href="/dashboard">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">
                <span>Allotment Mutation</span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <!-- BEGIN: Card -->
            <div class="card card-plb">
              <!-- BEGIN: Card Header -->
              <div class="card-header ui-sortable-handle">
                <h5 class="card-title card_title_margin">
                  <i class="nav-icon fa-solid fa-warehouse"></i>
                  Allotment Mutation
                </h5>
                <div class="card-tools">
                  <button
                    type="button"
                    data-card-widget="collapse"
                    class="btn btn-tool"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <!-- END: Card Header -->
              <!-- BEGIN: Card Body -->
              <!-- BEGIN: Filter Tabel -->
              <div class="card-body">
                <!-- BEGIN: Filter Data -->
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <form
                      @submit.prevent
                      class="form-horizontal"
                      enctype="multipart/form-data"
                    >
                      <div class="form-group row mt-4">
                        <label class="col-sm-3 col-form-label"
                          >Tanggal Posting</label
                        >
                        <div class="col-sm-4">
                          <datepicker
                            input-class="form-control"
                            placeholder="Dari Tanggal"
                            format="MM/dd/yyyy"
                            v-model="filter_start_date"
                          />
                        </div>
                        <div class="col-sm-4">
                          <datepicker
                            input-class="form-control"
                            placeholder="Sampai Tanggal"
                            format="MM/dd/yyyy"
                            v-model="filter_end_date"
                          />
                        </div>
                      </div>

                      <div class="form-group row justify-content-center">
                        <div class="col-sm-6">
                          <button class="btn btn-primary" @click="filterButton">
                            <i class="fa-solid fa-magnifying-glass"></i>
                            Filter
                          </button>
                          <button class="btn btn-secondary" @click="clearForm">
                            <i class="fa-solid fa-rotate"></i> Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- END: Filter Data -->
                <hr/>

                <!-- BEGIN: Tampil Data -->
                <div class="w-75 mx-auto form-group mt-4">
                  <div class="vgt-wrap polar-bear">
                    <div class="vgt-inner-wrap">
                      <!-- BEGIN: Table Fitler -->
                      <div class="vgt-responsive">
                        <table
                          id="vgt-table"
                          class="vgt-table bordered polar-bear"
                        >
                          <!-- BEGIN: Table Header -->
                          <thead class="text-center">
                            <!-- BEGIN: Table Sort & Label -->
                            <tr>
                              <th class="p-2" rowspan="2" colspan="2">OSA</th>
                              <th class="p-2" :colspan="hub_list.length">Plant Tujuan</th>
                            </tr>
                            <tr>
                              <th class="p-2" v-for="hub in hub_list" :key="hub.value">{{ hub.label }}</th>
                              <!-- <th class="p-2">KNO</th>
                              <th class="p-2">UPG</th>
                              <th class="p-2">SUB</th>
                              <th class="p-2">BPN</th>
                              <th class="p-2">DPS</th>
                              <th class="p-2">CGK</th>
                              <th class="p-2">PLB GMF</th> -->
                            </tr>
                            <tr>
                              <th class="p-2" :rowspan="hub_list.length + 1">Plant Asal</th>
                            </tr>

                            <tr v-for="hub_asal in hub_list" :key="hub_asal.value">
                              <th class="p-2">{{ hub_asal.label }}</th>
                              <td
                                class="p-2"
                                v-for="hub_tujuan in hub_list"
                                :key="hub_tujuan.value"
                                @click="filtered && toggleTable(hub_asal.value, hub_tujuan.value)"
                                style="cursor: pointer"
                                :style="{
                                  cursor: filtered ? 'pointer' : 'default',
                                  backgroundColor: active == hub_asal.value+'_'+hub_tujuan.value ? '#526D82' : 'white',
                                  color: active == hub_asal.value+'_'+hub_tujuan.value ? 'white' : 'black',
                                }"
                              >
                                {{ filtered ? (osa_data[hub_asal.value] ? osa_data[hub_asal.value][hub_tujuan.value] : 0) : '' }}
                              </td>
                            </tr>

                            <!-- List KNO -->
                            <!-- <tr>
                              <th class="p-2">KNO</th>
                              <td
                                class="p-2"
                                v-for="(kno_item, kno_key) in hub_kno"
                                :key="kno_key"
                                @click="toggleTable('KNO', kno_key)"
                                style="cursor: pointer"
                                :style="{
                                  backgroundColor: active == 'KNO_'+kno_key ? '#526D82' : 'white',
                                  color:active == 'KNO_'+kno_key  ? 'white' : 'black',
                                }"
                              >
                                {{ kno_item }}
                              </td>
                            </tr> -->

                            <!-- List UPG -->
                            <!-- <tr>
                              <th class="p-2">UPG</th>
                              <td
                                class="p-2"
                                v-for="(upg_item, upg_key) in hub_upg"
                                :key="upg_key"
                                @click="toggleTable('UPG', upg_key)"
                                style="cursor: pointer"
                                :style="{
                                  backgroundColor: active == 'UPG_'+upg_key ? '#526D82' : 'white',
                                  color:active == 'UPG_'+upg_key  ? 'white' : 'black',
                                }"
                              >
                                {{ upg_item }}
                              </td>
                            </tr> -->

                            <!-- List SUB -->
                            <!-- <tr>
                              <th class="p-2">SUB</th>
                              <td
                                class="p-2"
                                v-for="(sub_item, sub_key) in hub_sub"
                                :key="sub_key"
                                @click="toggleTable('SUB', sub_key)"
                                style="cursor: pointer"
                                :style="{
                                  backgroundColor: active == 'SUB_'+sub_key ? '#526D82' : 'white',
                                  color:active == 'SUB_'+sub_key  ? 'white' : 'black',
                                }"
                              >
                                {{ sub_item }}
                              </td>
                            </tr> -->

                            <!-- List BPN -->
                            <!-- <tr>
                              <th class="p-2">BPN</th>
                              <td
                                class="p-2"
                                v-for="(bpn_item, bpn_key) in hub_bpn"
                                :key="bpn_key"
                                @click="toggleTable('BPN', bpn_key)"
                                style="cursor: pointer"
                                :style="{
                                  backgroundColor: active == 'BPN_'+bpn_key ? '#526D82' : 'white',
                                  color:active == 'BPN_'+bpn_key  ? 'white' : 'black',
                                }"
                              >
                                {{ bpn_item }}
                              </td>
                            </tr> -->

                            <!-- List DPS -->
                            <!-- <tr>
                              <th class="p-2">DPS</th>
                              <td
                                class="p-2"
                                v-for="(dps_item, dps_key) in hub_dps"
                                :key="dps_key"
                                @click="toggleTable('DPS', dps_key)"
                                style="cursor: pointer"
                                :style="{
                                  backgroundColor: active == 'DPS_'+dps_key ? '#526D82' : 'white',
                                  color:active == 'DPS_'+dps_key  ? 'white' : 'black',
                                }"
                              >
                                {{ dps_item }}
                              </td>
                            </tr> -->

                            <!-- List CGK -->
                            <!-- <tr>
                              <th class="p-2">CGK</th>
                              <td
                                class="p-2"
                                v-for="(cgk_item, cgk_key) in hub_cgk"
                                :key="cgk_key"
                                @click="toggleTable('CGK', cgk_key)"
                                style="cursor: pointer"
                                :style="{
                                  backgroundColor: active == 'CGK_'+cgk_key ? '#526D82' : 'white',
                                  color:active == 'CGK_'+cgk_key  ? 'white' : 'black',
                                }"
                              >
                                {{ cgk_item }}
                              </td>
                            </tr> -->

                            <!-- List PLB GMF -->
                            <!-- <tr>
                              <th class="p-2">PLB GMF</th>
                              <td
                                class="p-2"
                                v-for="(gmf_item, gmf_key) in hub_gmf"
                                :key="gmf_key"
                                @click="toggleTable('GMF', gmf_key)"
                                style="cursor: pointer"
                                :style="{
                                  backgroundColor: active == 'GMF_'+gmf_key ? '#526D82' : 'white',
                                  color:active == 'GMF_'+gmf_key  ? 'white' : 'black',
                                }"
                              >
                                {{ gmf_item }}
                              </td>
                            </tr> -->
                            <!-- END: Table Sort & Label -->
                          </thead>
                          <!-- END: Table Header -->
                        </table>
                      </div>
                      <!-- END: Table Fitler -->
                    </div>
                  </div>

                  <!-- START: View All Button -->
                  <div  v-if="filtered" class="row mt-4 justify-content-center">
                    <button class="btn btn-primary" @click="toggleTable()">
                      <i class="fa-solid fa-eye"></i>
                      View All
                    </button>
                  </div>
                  <!-- END: View All Button -->
                </div>
                <!-- END: Tampil Data -->
              </div>
              <!-- END: Filter Tabel -->
              <!-- END: Card Body -->

              <!-- Detail List Data -->
              <div class="card-body" v-if="showTable">
                <!-- BEGIN: Tampil Data -->
                <div class="form-group">
                  <div class="vgt-wrap polar-bear">
                    <div class="vgt-inner-wrap">
                      <!-- Header -->
                      <div class="row ml-1 mb-2">
                        <h5 class="text-end">Detail List</h5>
                      </div>

                      <!-- BEGIN : Global Search -->
                      <div class="vgt-global-search vgt-clearfix">
                        <div class="vgt-global-search__input vgt-pull-left">
                          <label>
                            <span aria-hidden="true" class="input__icon">
                              <div class="magnifying-glass"></div>
                            </span>
                            <span class="sr-only"> Search </span>
                          </label>
                          <input
                            type="text"
                            placeholder="Search Data"
                            class="vgt-input vgt-pull-left"
                            v-model="search"
                            @change="listDetail()"
                          />
                        </div>
                        <div class="vgt-global-search__actions vgt-pull-right">
                          <div>
                            <button
                              class="btn btn-secondary ms-auto rounded-1"
                              @click="exportCsv"
                            >
                              <i class="fa-solid fa-file-csv"></i>
                              CSV
                            </button>
                            <button
                              class="btn btn-secondary ms-auto rounded-1"
                              style="margin-right: 10px"
                              @click="exportExcel"
                            >
                              <i class="fa-solid fa-file-excel"></i>
                              Excel
                            </button>
                            <!-- <button
                              class="btn btn-secondary ms-auto rounded-1"
                             
                            >
                              <i class="fa-solid fa-file-pdf"></i>
                              PDF
                            </button> -->
                          </div>
                        </div>
                      </div>
                      <!-- END :  Global Search -->

                      <!-- Table -->
                      <div class="vgt-responsive">
                        <table
                          id="vgt-table"
                          class="vgt-table bordered polar-bear"
                        >
                          <thead>
                            <tr>
                              <!-- Jenis Dokumen -->
                              <th>No</th>
                              <!-- BEGIN: Hub Plant Asal -->
                              <th
                                v-if="order == 'hub_plant_asal' && by == 'asc'"
                                @click="sort('hub_plant_asal', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Hub Plan Asal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'hub_plant_asal' && by == 'desc'
                                "
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Hub Plan Asal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('hub_plant_asal', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Hub Plan Asal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Hub Plant Asal -->
                              <!-- BEGIN: Sub Plant Asal -->
                              <th
                                v-if="order == 'sub_plant_asal' && by == 'asc'"
                                @click="sort('sub_plant_asal', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Sub Plant Asal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'sub_plant_asal' && by == 'desc'
                                "
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Sub Plant Asal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('sub_plant_asal', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Sub Plant Asal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Sub Plant Asal -->
                              <!-- BEGIN: Hub Plant Tujaun -->
                              <th
                                v-if="
                                  order == 'hub_plant_tujuan' && by == 'asc'
                                "
                                @click="sort('hub_plant_tujuan', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header"
                                  >Hub Plant Tujaun</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'hub_plant_tujuan' && by == 'desc'
                                "
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header"
                                  >Hub Plant Tujaun</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('hub_plant_tujuan', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header"
                                  >Hub Plant Tujaun</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Hub Plant Tujaun -->

                              <!-- BEGIN: Sub Plant Tujuan -->
                              <th
                                v-if="
                                  order == 'sub_plant_tujuan' &&
                                  by == 'asc'
                                "
                                @click="sort('sub_plant_tujuan', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header"
                                  >Sub Plant Tujuan</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'sub_plant_tujuan' &&
                                  by == 'desc'
                                "
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header"
                                  >Sub Plant Tujuan</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('sub_plant_tujuan', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header"
                                  >Sub Plant Tujuan</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Sub Plant Tujuan -->

                              <!-- BEGIN: Kode Barang -->
                              <th
                                v-if="order == 'kode_barang' && by == 'asc'"
                                @click="sort('kode_barang', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'kode_barang' && by == 'desc'
                                "
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Kode Barang -->
                              <!-- BEGIN: Nama Barang -->
                              <th
                                v-if="order == 'nama_barang' && by == 'asc'"
                                @click="sort('nama_barang', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'nama_barang' && by == 'desc'
                                "
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('nama_barang', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Nama Barang -->

                              <!-- BEGIN: Nomor Pengiriman -->
                              <th
                                v-if="
                                  order == 'nomor_pengiriman' && by == 'asc'
                                "
                                @click="sort('nomor_pengiriman', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header"
                                  >Nomor Pengiriman</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'nomor_pengiriman' && by == 'desc'
                                "
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header"
                                  >Nomor Pengiriman</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('nomor_pengiriman', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header"
                                  >Nomor Pengiriman</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Nomor Pengiriman -->
                              <!-- BEGIN: Tanggal -->
                              <th
                                v-if="order == 'tanggal' && by == 'asc'"
                                @click="sort('tanggal', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Tanggal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'tanggal' && by == 'desc'"
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Tanggal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('tanggal', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Tanggal</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Tanggal -->

                              <!-- BEGIN: Matdoc & Item -->
                              <th
                                v-if="order == 'matdoc_item' && by == 'asc'"
                                @click="sort('matdoc_item', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Matdoc & Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'matdoc_item' && by == 'desc'
                                "
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Matdoc & Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('matdoc_item', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Matdoc & Item</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- BEGIN: Jumlah -->
                              <th
                                v-if="order == 'jumlah' && by == 'asc'"
                                @click="sort('jumlah', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Jumlah</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'jumlah' && by == 'desc'"
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Jumlah</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('jumlah', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Jumlah</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Jumlah -->
                              <!-- BEGIN: Satuan -->
                              <th
                                v-if="order == 'satuan' && by == 'asc'"
                                @click="sort('satuan', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'satuan' && by == 'desc'"
                                @click="sort('kode_barang', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('satuan', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Satuan -->
                            </tr>

                            <!-- BEGIN: Filter -->
                            <tr>
                              <th class="filter-th"></th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Hub Plant Asal"
                                    v-model="search_hub_plant_asal"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Sub Plant Asal"
                                    v-model="search_sub_plant_asal"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Hub Plant Tujuan"
                                    v-model="search_hub_plant_tujuan"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Sub Plant Tujuan"
                                    v-model="search_sub_plant_tujuan"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Kode Barang"
                                    v-model="search_kode_barang"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Nama Barang"
                                    v-model="search_nama_barang"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Nomor Pengiriman"
                                    v-model="search_nomor_pengiriman"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="date"
                                    class="vgt-input text-center"
                                    placeholder="Tanggal"
                                    v-model="search_tanggal"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Nama Barang"
                                    v-model="search_matdoc_item"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Jumlah"
                                    v-model="search_jumlah"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Satuan"
                                    v-model="search_satuan"
                                    @change="listDetail()"
                                  />
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <!-- END: Table Head -->

                          <!-- BEGIN: Table Body -->
                          <tbody>
                            <!-- BEGIN: Table Content -->
                            <tr
                              v-for="(
                                allotment, allotment_index
                              ) in allotments.data"
                              :key="allotment_index"
                            >
                              <!-- BEGIN: Content No -->
                              <td class="text-center table-content">
                                {{ allotments.from + allotment_index }}
                              </td>
                              <!-- END: Content No -->

                              <!-- BEGIN: Content Hub Plant Asal  -->
                              <td class="text-center table_content">
                                {{ allotment.HUB_PLANT_ASAL }}
                              </td>
                              <!-- END: Content Hub Plant Asal -->

                              <!-- BEGIN: Content Sub Plant Asal  -->
                              <td class="text-center table_content">
                                {{ allotment.SUB_PLANT_ASAL }}
                              </td>
                              <!-- END: Content Sub Plant Asal -->

                              <!-- BEGIN: Content Hub Plant Tujuan  -->
                              <td class="text-center table_content">
                                {{ allotment.HUB_PLANT_TUJUAN }}
                              </td>
                              <!-- END: Content Hub Plant Tujuan -->

                              <!-- BEGIN: Content Sub Plant Tujuan  -->
                              <td class="text-center table_content">
                                {{ allotment.SUB_PLANT_TUJUAN }}
                              </td>
                              <!-- END: Content Sub Plant Tujuan -->

                              <!-- BEGIN: Content Kode Barang  -->
                              <td class="text-center table_content">
                                {{ allotment.KODE_BARANG }}
                              </td>
                              <!-- END: Content Kode Barang -->

                              <!-- BEGIN: Content Nama Barang  -->
                              <td class="text-center table_content">
                                {{ allotment.NAMA_BARANG }}
                              </td>
                              <!-- END: Content Nama Barang -->

                              <!-- BEGIN: Content Nomor Pengiriman  -->
                              <td class="text-center table_content">
                                {{ allotment.NOMOR_PENGIRIMAN }}
                              </td>
                              <!-- END: Content Nomor Pengiriman -->

                              <!-- BEGIN: Content Tanggal  -->
                              <td class="text-center table_content">
                                {{ allotment.TANGGAL }}
                              </td>
                              <!-- END: Content Tanggal -->

                              <!-- BEGIN: Content Matdoc & Item  -->
                              <td class="text-center table_content">
                                {{ allotment.MATDOC_ITEM }}
                              </td>
                              <!-- END: Content Matdoc & Item -->

                              <!-- BEGIN: Content Jumlah  -->
                              <td class="text-center table_content">
                                {{ allotment.JUMLAH }}
                              </td>
                              <!-- END: Content Jumlah -->

                              <!-- BEGIN: Content Satuan  -->
                              <td class="text-center table_content">
                                {{ allotment.SATUAN }}
                              </td>
                              <!-- END: Content Satuan -->
                            </tr>
                            <tr v-if="allotments.data.length < 1">
                              <td colspan="20">
                                <div class="vgt-center-align vgt-text-disabled">
                                  Data not found
                                </div>
                              </td>
                            </tr>
                          </tbody>

                          <!-- END: Table Body -->
                        </table>
                      </div>
                      <div class="vgt-wrap__footer vgt-clearfix">
                        <div class="footer__row-count vgt-pull-left">
                          <label
                            class="footer__row-count__label row_per_page_label"
                          >
                            Rows per page:
                          </label>
                          <select
                            class="footer__row-count__select row_per_page_option"
                            v-model="paginate"
                            @change="listDetail()"
                          >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                        <div class="footer__navigation vgt-pull-right">
                          <button
                            type="button"
                            class="footer__navigation__page-btn"
                            :class="{
                              disabled: !allotments.prev_page_url,
                            }"
                            @click="
                              allotments.prev_page_url &&
                                listDetail(allotments.prev_page_url)
                            "
                            style="margin-right: 0px"
                          >
                            <span
                              aria-hidden="true"
                              class="chevron left"
                            ></span>
                            <span class="paginate_text">Prev</span>
                          </button>
                          <div
                            class="footer__navigation__page-info"
                            style="color: #99a0b2"
                          >
                            <label
                              class="page-info__label"
                              style="margin-bottom: -5px"
                            >
                              <span class="paginate_text">page</span>
                              <input
                                type="text"
                                class="footer__navigation__page-info__current-entry vgt-input"
                                v-model="current_page"
                                @keypress="directPage"
                                style="width: 60px"
                              />
                              <span class="paginate_text">
                                of
                                {{ allotments.last_page }}
                              </span>
                            </label>
                          </div>
                          <button
                            type="button"
                            class="footer__navigation__page-btn"
                            :class="{
                              disabled: !allotments.next_page_url,
                            }"
                            @click="
                              allotments.next_page_url &&
                                listDetail(allotments.next_page_url)
                            "
                          >
                            <span style="font-weight: 500">Next</span>
                            <span
                              aria-hidden="true"
                              class="chevron right"
                            ></span>
                          </button>
                        </div>
                      </div>
                      <!-- End Table -->
                    </div>
                  </div>
                </div>
                <!-- END: Tampil Data -->
              </div>
              <!-- End Detail List Data -->
            </div>
            <!-- END: Card -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";
import moment from "moment";
import Swal from "sweetalert2";
moment.locale("id");

export default {
  data() {
    return {
      showTable: false,
      active: null,
      filtered: false,

      allotments: {
        data: [],
        links: [],
      },

      // hub_kno: [],
      // hub_upg: [],
      // hub_cgk: [],
      // hub_sub: [],
      // hub_bpn: [],
      // hub_dps: [],
      // hub_gmf: [],

      hub_list: [],
      osa_data: {},

      date_note: moment(Date.now()),

      // Search Data
      search: null, // Search All Data
      search_hub_plant_asal: null,
      search_sub_plant_asal: null,
      search_hub_plant_tujuan: null,
      search_sub_plant_tujuan: null,
      search_kode_barang: null,
      search_nama_barang: null,
      search_nomor_pengiriman: null,
      search_tanggal: null,
      search_matdoc_item: null,
      search_jumlah: null,
      search_satuan: null,
      export_type: null,

      // Order By
      order: "kode_barang",
      by: "asc",
      paginate: "10",
      current_page: null,

      // Filter
      filter_start_date: null,
      filter_end_date: null,
      filter_hub_asal: null,
      filter_hub_tujuan: null,
    };
  },

  created() {
    this.loadFilters();
   },

  methods: {
    // this.showTable = !this.showTable;
    toggleTable(hub_asal = null, hub_tujuan = null) {
      this.active = hub_asal+'_'+hub_tujuan;
      this.showLoading();
      axios
        .get(`/api/allotment-mutation-detail`, {
          params: {
            // Filter
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
            filter_hub_asal: hub_asal,
            filter_hub_tujuan: hub_tujuan,
          },
        })
        .then((response) => {
          this.filter_hub_asal = hub_asal;
          this.filter_hub_tujuan = hub_tujuan;

          this.allotments = response.data;
          this.showTable = true;

          this.hideLoading();
          this.showSuccessRequest();
        })
        .catch((error) => {
          this.hideLoading();
          this.showErrorRequest();
          console.log(error);
        });
    },
    created() {
      this.list();
      this.listDetail();
    },

    loadFilters() {
      axios.get('/api/allotment-mutation/show-filters')
        .then(response => {
          this.hub_list = response.data.data;
        });
    },

    // Allotment Posting
    list(url) {
      this.showTable = false;
      this.active = null;
      this.showLoading();
      url = `/api/allotment-mutation`;
      axios
        .get(url, {
          params: {
            // Filter
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
          },
        })
        .then((response) => {
          // this.hub_kno = response.data.KNO;
          // this.hub_upg = response.data.UPG;
          // this.hub_sub = response.data.SUB;
          // this.hub_bpn = response.data.BPN;
          // this.hub_dps = response.data.DPS;
          // this.hub_cgk = response.data.CGK;
          // this.hub_gmf = response.data.GMF;
          this.osa_data = response.data;

          this.filtered = true;
          this.hideLoading();
          this.showSuccessRequest();
        })
        .catch((error) => {
          this.hideLoading();
          this.showErrorRequest();
          console.log(error);
        });
    },

    // Allotment Detail
    listDetail(paginate) {
      this.showLoading();
      paginate = paginate || `/api/allotment-mutation-detail`;
      axios
        .get(paginate, {
          params: {
            // Search
            search: this.search,
            search_hub_plant_asal: this.search_hub_plant_asal,
            search_sub_plant_asal: this.search_sub_plant_asal,
            search_hub_plant_tujuan: this.search_hub_plant_tujuan,
            search_sub_plant_tujuan: this.search_sub_plant_tujuan,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_nomor_pengiriman: this.search_nomor_pengiriman,
            search_tanggal: this.search_tanggal,
            search_matdoc_item: this.search_matdoc_item,
            search_jumlah: this.search_jumlah,
            search_satuan: this.search_satuan,

            // Filter
            filter_hub_asal: this.filter_hub_asal,
            filter_hub_tujuan: this.filter_hub_tujuan,
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,

            // Order, By and Paginate
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
        })
        .then((response) => {
          this.allotments = response.data;

          this.current_page = this.allotments.current_page;
          this.hideLoading();
          this.showSuccessRequest();
        })
        .catch((error) => {
          this.hideLoading();
          this.showErrorRequest();
          console.log(error);
        });
    },

    // BEGIN : Export Excel
    exportExcel() {
      this.showLoading();
      axios
        .get("/api/allotment-mutation-export", {
          params: {
            // Search
            search: this.search,
            search_hub_plant_asal: this.search_hub_plant_asal,
            search_sub_plant_asal: this.search_sub_plant_asal,
            search_hub_plant_tujuan: this.search_hub_plant_tujuan,
            search_sub_plant_tujuan: this.search_sub_plant_tujuan,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_nomor_pengiriman: this.search_nomor_pengiriman,
            search_tanggal: this.search_tanggal,
            search_matdoc_item: this.search_matdoc_item,
            search_jumlah: this.search_jumlah,
            search_satuan: this.search_satuan,
            export_type: 'xlsx',
            
            // Filter
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
            filter_hub_asal: this.filter_hub_asal,
            filter_hub_tujuan: this.filter_hub_tujuan,

            // Order, By and Paginate
            order: this.order,
            by: this.by,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "allotment-mutation.xlsx");
          document.body.appendChild(link);
          link.click();

          Swal.close();
          this.hideLoading();
          this.showSuccessExport();
        })
        .catch((error) => {
          console.log(error);
          Swal.close();
          this.hideLoading();
          this.showErrorExport();
        });
    },

    // BEGIN : Export CSV
    exportCsv() {
      this.showLoading();
      axios
        .get("/api/allotment-mutation-export", {
          params: {
            // Search
            search: this.search,
            search_hub_plant_asal: this.search_hub_plant_asal,
            search_sub_plant_asal: this.search_sub_plant_asal,
            search_hub_plant_tujuan: this.search_hub_plant_tujuan,
            search_sub_plant_tujuan: this.search_sub_plant_tujuan,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_nomor_pengiriman: this.search_nomor_pengiriman,
            search_tanggal: this.search_tanggal,
            search_matdoc_item: this.search_matdoc_item,
            search_jumlah: this.search_jumlah,
            search_satuan: this.search_satuan,
            export_type: 'csv',

            // Filter
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
            filter_hub_asal: this.filter_hub_asal,
            filter_hub_tujuan: this.filter_hub_tujuan,

            // Order, By and Paginate
            order: this.order,
            by: this.by,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "allotment-mutation.csv");
          document.body.appendChild(link);
          link.click();

          Swal.close();
          this.hideLoading();
          this.showSuccessExport();
        })
        .catch((error) => {
          console.log(error);
          Swal.close();
          this.hideLoading();
          this.showErrorExport();
        });
    },
    filterButton() {
      if (!this.filter_start_date || !this.filter_end_date) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan pilih Tanggal Posting terlebih dahulu!",
        });
      } else {
        this.list();
      }
    },
    clearForm() {
      this.showTable = false;
      this.active = null;
      this.filtered = false;

      // this.hub_kno = [];
      // this.hub_upg = [];
      // this.hub_cgk = [];
      // this.hub_sub = [];
      // this.hub_bpn = [];
      // this.hub_dps = [];
      // this.hub_gmf = [];

      this.osa_data = {};

      this.allotments.data = [];
      this.allotments.links = [];

      this.filter_start_date = null;
      this.filter_end_date = null;

      this.filter_hub_asal = null;
      this.filter_hub_tujuan = null;
      this.search = null;
      this.search_hub_plant_asal = null;
      this.search_sub_plant_asal = null;
      this.search_hub_plant_tujuan = null;
      this.search_sub_plant_tujuan = null;
      this.search_kode_barang = null;
      this.search_nama_barang = null;
      this.search_nomor_pengiriman = null;
      this.search_tanggal = null;
      this.search_matdoc_item = null;
      this.search_jumlah = null;
      this.search_satuan = null;

      this.order = "kode_barang";
      this.by = "asc";
      this.paginate = "10";
    },

    directPage: debounce(function () {
      if (this.current_page < 1) {
        this.current_page = 1;
      } else if (this.current_page > this.allotments.last_page) {
        this.current_page = this.allotments.last_page;
      }

      let url = new URL(this.allotments.first_page_url);
      let search_params = url.searchParams;
      search_params.set("page", this.current_page);

      url.search = search_params.toString();
      let new_url = url.toString();
      this.listDetail(new_url);
    }, 500),
    sort(order, by) {
      this.order = order;
      this.by = by;
      this.listDetail();
    },
    showLoading() {
      Swal.fire({
        didOpen: () => {
          Swal.showLoading();
        },
        background: "transparent",
        allowOutsideClick: false,
      });
    },

    hideLoading() {
      Swal.close();
    },

    showSuccessRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Successfully Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showErrorRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showSuccessExport() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Successfully Export Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showErrorExport() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Export Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
  },
};
</script>
<style scoped>
.vgt-global-search__input .input__icon .magnifying-glass {
  margin-top: -3px;
}

.note {
  color: #007bff;
  font-weight: bold;
}
</style>
